/**
 * Configuração de colisão para o castelo
 *
 * Este arquivo contém a configuração para as caixas de colisão do castelo.
 * Usando múltiplas caixas de colisão, podemos criar uma representação mais precisa
 * da forma do castelo, incluindo suas torres e estruturas curvas.
 */

// Interface para uma única caixa de colisão
export interface CollisionBox {
  position: {
    x: number;
    y: number;
    z: number;
  };
  size: {
    width: number;
    height: number;
    depth: number;
  };
}

// Interface para a configuração do castelo com múltiplas caixas de colisão
export interface CastleCollisionConfig {
  id: string;
  collisionBoxes: CollisionBox[];
  isAnimated: boolean;
}

// Configuração do castelo com 4 caixas de colisão
// Simplificado para permitir ajustes manuais mais fáceis
export const defaultCastleConfig: CastleCollisionConfig = {
  id: 'fantasy-castle',
  collisionBoxes: [
    // Caixa principal (base do castelo) - estendida até o chão
    {
      position: { x: -24, y: 10, z: 310 },
      size: { width: 25, height: 35, depth: 36 }
    },

    // Caixa secundária (torres e estruturas superiores) - estendida até o chão
    {
      position: { x: -23, y: 10, z: 292 },
      size: { width: 14, height: 9, depth: 45 }
    },

    // Caixa terciária (área adicional) - estendida até o chão
    {
      position: { x: -38, y: 10, z: 311 },
      size: { width: 12, height: 13, depth: 6 }
    },

    // Caixa quaternária (pequena área adicional) - estendida até o chão
    {
      position: { x: -10, y: 10, z: 320 },
      size: { width: 8, height: 15, depth: 8 }
    },

    // Caixa adicional para cobrir o espaço entre as caixas principais
    {
      position: { x: -30, y: 10, z: 300 },
      size: { width: 30, height: 10, depth: 30 }
    }
  ],
  isAnimated: false
};

export default defaultCastleConfig;
